package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_03_22_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes begin the day with a nice breakfast. Bigglesworth pays 2 gold. Zolnur meets the heroes as they are leaving. A stable hand brings the Aloysius (marsh cow) and Flower (horse) to the heroes. It takes about three hours to get to the gate. The heroes once again marvel at the mortared rocks of the 10 foot thick, well-engineered wall.  Outside these walls are the lower classes of society and also farms.  Zolnur explains to the heroes that the nearby cities respect the sovereignty of the free city.")
    }
}
